module.exports = __webpack_public_path__ + "static/media/weather-icon.a407451a.svg";